import React, { useEffect } from "react"
import { useDispatch } from "react-redux"

import { withApp } from "@/components/App"
import TemplateSlice, { setTemplate } from "@/onboarding/features/product/templateSlice"
import Edit from "@/onboarding/features/component_library/components/Edit"

const Initializer = (props): JSX.Element => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (props.template) dispatch(setTemplate(props.template))
  }, [props.template])

  return <Edit {...props} />
}

export default withApp(Initializer, { slices: [TemplateSlice] })
